import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f57a62c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("新建送货单")
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-end","padding-top":"8px"} }
const _hoisted_9 = {
  class: "drawer_content",
  style: {"height":"100%","box-sizing":"border-box","display":"flex","flex-direction":"column"}
}
const _hoisted_10 = {
  class: "titleButton",
  style: {"flex-shrink":"0"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "送货单详情编辑", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "title",
  style: {"color":"red"}
}, " 编辑送货单明细需要重新打印送货单号，否则无法进行扫码收货! ", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定 ")
const _hoisted_14 = { style: {"flex-grow":"1","height":"1px","overflow":"auto"} }
const _hoisted_15 = { class: "Delivery" }
const _hoisted_16 = { class: "Delivery_div" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-plus" }, null, -1))
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确认")

import { ref, reactive, onMounted, nextTick, defineAsyncComponent,computed } from "vue";
import { getDeliveryAppointment, createRanDelivery, addDeliveryNoList, deteleDeliveryNoList, commitDelivery, getPrDetails, getOrderData, getShipAddress, getDeliveryStatusApi,
  PurchaseOrderdetails
} from '@/service/main/supplier/index'
import { readERP, getDeliveryOrderManagementPage, getCreatingShipOrderPage, systemDeNo, createDeliOrder, secondJundgment, nonstandardList, createNonstandad } from '@/service/main/supplier/index'
import {
  getDeliveryDetailsData,
  deleteJundgment,
  getSendShipOrderPage,
  createDeliOrders,
  CreateJiaJiJianList
} from "@/service/main/supplier/index";
import {
  getDetailsText,
  getDetailsStatus,
  getInspectionMethod,
  getEditStatus
} from "../switchCase";
import Pagination from "@/components/Pagination/index.vue";
import dragMenu from "@/components/drag-menu/index.vue";
import { ElMessage, ElMessageBox, ElLoading, ElTable } from "element-plus";
import { getDicListData } from "@/service/main/warehouse/dicWare";
import { getWarsehouseDicValueList } from "@/service/main/warehouse";
import { getStatus,getText } from '../switchCase'
// import store from "@/store";
// import infoBlock from './infoBlock.vue'
import type { UploadProps, UploadUserFile } from 'element-plus'
import { downLoadRecordFunction } from '@/service/main/downLoad/index'

// 图片上传
import { useStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const infoBlock = defineAsyncComponent(() => import("./infoBlock.vue"));
const infoAdd = defineAsyncComponent(() => import("./infoAdd.vue"));
const addDeliver = defineAsyncComponent(() => import("./addDeliver.vue"));
const actionUrl = computed(() => process.env.VUE_APP_BASE_URL+ '/api/sysFileInfo/upload')
//headers
const store = useStore();
const token = computed(() => store.state.login.token)
const headerObj = ref({
    Authorization: `Bearer ${token.value}`
});

// 顶部占位过多 展开/收起
const hidden = ref(false);
const openSearch = () => {
  hidden.value = !hidden.value;
};

const user = computed(() => store.state.login.userInfo.account)
// 禁止选择项
// 新增/修改弹框数量为0不可选择
const selectableFunction = (row: any) => {
    if (row.outdeliveryQuantity != row.purchaseNumber + row.returnQuantity) {
        return true
    } else {
        return false
    }
}
//单元格样式设置
const rowClass = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.rowIndex === 0) {
    return "color: #606266;font-weight: bold;";
  }
};
const cellClass = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.column.label == "采购类型" && row.row.purchaseTypeName == "加急件") {
    return "color: #F56C6C;font-weight: bold;";
  }
};

// 列表的每一列
const checkList = ref(["状态", "项目编号", "采购单号", "采购类型", "送货总数", "已送数量", "剩余数量", "收货数量","入库数量","返修数量","采购日期", "创建时间", "更新时间", "收货地址", "操作"])
// 当前选中的多选框，代表当前展示的列
const checkedColumns = ref(["状态", "项目编号", "采购单号", "采购类型", "送货总数", "剩余数量", "收货数量","入库数量","返修数量","采购日期", "创建时间","收货地址", "操作"])

//查询
const formModel = reactive({
  purchaseNo: "",
  Status: "-10",
  ProjectCode: "",
  deliveryNo: "",
  IsJiaJiJian: -10,
  PageNo: 1,
  PageSize: 5
});

// 重置
const reset = () => {
  formModel.deliveryNo = "";
  formModel.Status = "-10";
  formModel.ProjectCode = "";
  formModel.purchaseNo = "";
  formModel.IsJiaJiJian = -10;
  formModel.PageNo = 1;
  formModel.PageSize = 5;
  getDeDetails();
};

// 送货单详情列表数据定义
const tableDataDeliveryDrawer = ref([]);
const singleTableRef = ref<InstanceType<typeof ElTable>>();
// 送货单详情列表分页
const totalItemsDeliveryDrawer = ref(0);
// 获取送货单详情数据
const getDeDetails = () => {
  getDeliveryOrderManagementPage(formModel).then((res) => {
    const { data } = res;
    tableDataDeliveryDrawer.value = data.rows;
    totalItemsDeliveryDrawer.value = data.totalRows;
    creatingShipDetail(tableDataDeliveryDrawer.value[0], null);
    singleTableRef.value!.setCurrentRow(tableDataDeliveryDrawer.value[0]);
  });
};
getDeDetails();
//详情
const detailsReset = () => {
  // info.value.PurchaseID = "";
  // info.value.DeliveryNo = "";
  infoType.value = "";
  infoShow.value = false;
};

const info = ref({ PurchaseID: "", DeliveryNo: "" });
const infoType = ref("");
const infoShow = ref(false);

const creatingShipDetail = async (scope: any, column: any) => {
  console.log('column',scope)
  // await detailsReset();
  if (column && column.label == "操作") return;
  if (scope.purchaseNo) {
    info.value = scope;
    refInfoBlock.value.show(scope)
    // info.value.DeliveryNo = scope.deliveryNo;
    // info.value.PurchaseID = scope.purchaseId;
    // infoType.value = scope.purchaseTypeName;
    infoShow.value = true;
  }
};
// 送货单状态下拉框数据定义
const storeEnum: any = ref([]);
const getSelect = () => {
  const obj = {
    CodeList: "shenhe_status"
  };
  getDicListData(obj).then((res) => {
    const { data } = res;
    storeEnum.value = data[0];
  });
};
getSelect();
// 获取是否加急下拉框数据
const isJiaJiJianEnum: any = ref([
  { label: "全部", value: -10 },
  { label: "是", value: 1 },
  { label: "否", value: 0 }
]);
// 删除
const deleteItemOrder = (row: any) => {
  const obj = {
    id: row.id,
    purchaseNo: row.purchaseNo
  };
  ElMessageBox.confirm("是否删除该条送货单？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      deleteJundgment(obj).then((res) => {
        getDeDetails();
        ElMessage.success("删除成功");
      });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

// 编辑送货单抽屉默认关闭状态
const drawers = ref(false);
// 查询编辑送货单列表数据接口参数定义
const creatingShipOrderParams = reactive({
  PurchaseID: "",
  DeliveryNo: "",
  PageNo: 1,
  PageSize: 10
});

// 新建送货单列表数据定义
const tableDataDrawer = ref([]);
const TableRef = ref();
const tableDataItems = ref<number>(0);
// 编辑
const editOrder = (scope: any = {}) => {
  creatingShipOrderParams.DeliveryNo = scope.deliveryNo;
  creatingShipOrderParams.PurchaseID = scope.purchaseId;
  saveData.deliveryType = scope.purchaseType;
  drawers.value = true;
  changerole(scope.purchaseTypeName);
};
const changerole = (scope: any) => {
  if (scope == "加急件") {
    JiaJiJianList();
  } else {
    getCreatingShipOrderData();
  }
};
// 获取新建送货单列表数据
const getCreatingShipOrderData = () => {
  // setTimeout(() => {
  //     loading.close()
  // }, 2000)
  getSendShipOrderPage(creatingShipOrderParams).then((res: any) => {
    console.log(res);
    const { data } = res;
    if (res.code == 200) {
      tableDataDrawer.value = data.rows;
      tableDataItems.value = data.totalRows;
      nextTick(() => {
        tableDataDrawer.value.forEach((row: any) => {
          if (row.isCheck) {
            TableRef.value.toggleRowSelection(row, true);
          }
        });
      });
    } else {
      ElMessage.warning(data.message);
    }
  });
};

//获取加急件列表数据
const JiaJiJianList = () => {
  // setTimeout(() => {
  //     loading.close()
  // }, 2000)
  CreateJiaJiJianList(creatingShipOrderParams).then((res: any) => {
    const { data } = res;
    tableDataDrawer.value = data.rows;
    tableDataItems.value = data.totalRows;
    nextTick(() => {
      tableDataDrawer.value.forEach((row: any) => {
        if (row.isCheck) {
          TableRef.value.toggleRowSelection(row, true);
        }
      });
    });
  });
};
let tableHeight = ref(0);
onMounted(() => {
  tableHeight.value = window.innerHeight - 10;
  // console.log('tableHeight',tableHeight.value)
});
// 定义新建送货单中选中的数据
const checkRows = ref([]);
// 送货单明细多选方法
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
  checkRows.value.forEach((item:any)=>{
    if(item.isCheck == false && item.notPurchaseNumber==0){
      nextTick(()=>{
        TableRef.value.toggleRowselection(item,false)//true为选中
      })      
    }    
  })
};
// 关闭新建送货单抽屉时的事件(Close)
const handleCloses = () => {
  creatingShipOrderParams.PurchaseID = "";
  creatingShipOrderParams.DeliveryNo = "";
  creatingShipOrderParams.PageNo = 1;
  creatingShipOrderParams.PageSize = 10;
  tableDataDrawer.value = [];
};
// 定义新建送货单接口参数
const saveData = reactive({
  purchaseID: 0,
  deliveryNo: "",
  deliveryType: "",
  goodsDeliveryDetailsInputList: [] as {
    projectCode: string;
    code: string;
    name: string;
    specificationModel: string;
    long: number;
    high: number;
    width: number;
    weight: number;
    unit: string;
    minUnit: string;
    deliveryQuantity: number;
    goodsDeliveryId: number;
    purchaseNo: string;
    PurchaseType: string;
  }[]
});
// 新建送货单确定
const confirmNewDeliveryOrder = () => {
  saveData.deliveryNo = creatingShipOrderParams.DeliveryNo;
  saveData.goodsDeliveryDetailsInputList = [];
  saveData.goodsDeliveryDetailsInputList = checkRows.value.filter(
    (scope: any) =>
      scope.deliveryQuantity <= scope.purchaseNumber + scope.returnQuantity - scope.outdeliveryQuantity
  );
  if (saveData.goodsDeliveryDetailsInputList.length == checkRows.value.length) {
    console.log('21312',saveData)
    ElMessageBox.confirm("是否确认编辑送货单？", "提示", {
      confirmButtonText: "确认",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(() => {
        createDeliOrders(saveData).then((res) => {
          drawers.value = false;
          getDeDetails();
          TableRef.value.clearSelection()
          ElMessage.success("编辑送货单成功");
        });
      })
      .catch(() => {
        ElMessage.info("已取消删除");
      });
  } else {
    ElMessage.warning("请检查本次发货数量是否准确");
  }
};

//详情
const addReset = () => {
  info.value.PurchaseID = "";
  info.value.DeliveryNo = "";
  infoType.value = "";
  infoShow.value = false;
};
// const infoAdd = ref({ PurchaseID: "", DeliveryNo: "" });
// const infoType = ref("");
const infoAddShow = ref(false);
const refInfoBlock = ref();

const addERPdata = async (scope: any, column: any) => {
  await addReset();
  if (column && column.label == "操作") return;
  if (scope.purchaseId) {
    info.value.DeliveryNo = scope.deliveryNo;
    info.value.PurchaseID = scope.purchaseId;
    infoType.value = scope.purchaseTypeName;
    infoAddShow.value = true;
  }
};
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const transportCompanyEnum: any = ref([])
const transportVehicleEnum: any = ref([])
const driverNameEnum: any = ref([])
const driverPhoneEnum: any = ref([])
const driverQualificationEnum: any = ref([])
const expressInfoNoEnum: any = ref([])
const collectDeliveryUserNameEnum: any = ref([])
const collectDeliveryUserPhoneEnum: any = ref([])
const deliverGoodsPlaceShipEnum: any = ref([])
const collectDeliveryPlaceShipEnum: any = ref([])
// 编辑送货预约窗口中表单数据绑定
const addForm = reactive({
    id: 0,
    deliveryId: 0,
    appointmentNo: "",
    transportCompany: "",
    expressInfoNo: "",
    transportVehicle: "",
    driverName: "",
    driverQualification: "",
    driverPhone: "",
    deliverGoodsPlaceShip: "",
    collectDeliveryPlaceShip: "",
    collectDeliveryUserName: "",
    collectDeliveryUserPhone: "",
    estimatedDate: "",
    deliverDate: "",
    images: [] as any
})

// 获取发货地址数据接口
const shipAddress = () => {
    getShipAddress().then((res) => {
        const { data } = res;
        // 处理后端数据
        // 运输公司
        if (data.transportCompanyList !== null) {
            transportCompanyEnum.value = unique(transportCompanyEnum.value)
            data.transportCompanyList.forEach((item: any) => {
                transportCompanyEnum.value.push({
                    label: item
                })
            })
        };

        //运输车辆
        if (data.transportVehicleList !== null) {
            transportVehicleEnum.value = unique(transportVehicleEnum.value)
            data.transportVehicleList.forEach((item: any) => {
                transportVehicleEnum.value.push({
                    label: item
                })
            })
        };

        // 司机姓名
        if (data.driverNameList !== null) {
            driverNameEnum.value = unique(driverNameEnum.value)
            data.driverNameList.forEach((item: any) => {
                driverNameEnum.value.push({
                    label: item
                })
            })
        };

        // 司机电话
        if (data.driverPhoneList !== null) {
            driverPhoneEnum.value = unique(driverPhoneEnum.value)
            data.driverPhoneList.forEach((item: any) => {
                driverPhoneEnum.value.push({
                    label: item
                })
            })
        };

        // 驾驶员资格
        if (data.driverQualificationList !== null) {
            driverQualificationEnum.value = unique(driverQualificationEnum.value)
            data.driverQualificationList.forEach((item: any) => {
                driverQualificationEnum.value.push({
                    label: item
                })
            })
        };

        // 物流单号
        if (data.expressInfoNoList !== null) {
            expressInfoNoEnum.value = unique(expressInfoNoEnum.value)
            data.expressInfoNoList.forEach((item: any) => {
                expressInfoNoEnum.value.push({
                    label: item
                })
            })
        };

        // 收货人
        if (data.collectDeliveryUserNameList !== null) {
            collectDeliveryUserNameEnum.value = unique(collectDeliveryUserNameEnum.value)
            data.collectDeliveryUserNameList.forEach((item: any) => {
                collectDeliveryUserNameEnum.value.push({
                    label: item
                })
            })
        };

        // 收货人电话
        if (data.collectDeliveryUserPhoneList !== null) {
            collectDeliveryUserPhoneEnum.value = unique(collectDeliveryUserPhoneEnum.value)
            data.collectDeliveryUserPhoneList.forEach((item: any) => {
                collectDeliveryUserPhoneEnum.value.push({
                    label: item
                })
            })
        };

        // 发货地址
        if (data.deliverGoodsPlaceShipList!== null) {
            
            deliverGoodsPlaceShipEnum.value = unique(deliverGoodsPlaceShipEnum.value)
            data.deliverGoodsPlaceShipList.forEach((item: any) => {
                deliverGoodsPlaceShipEnum.value.push({
                    label: item
                })
            })
        };

         // 收货地址
         if (data.collectDeliveryPlaceShip!== null) {
            collectDeliveryPlaceShipEnum.value = unique(collectDeliveryPlaceShipEnum.value)            
            data.collectDeliveryPlaceShip.forEach((item: any) => {                
                collectDeliveryPlaceShipEnum.value.push({
                    label: item
                })
            })
        };
    })
}
const unique = (arr: any) => {
    const res = new Map();
    return arr.filter((arr: any) => !res.has(arr.id) && res.set(arr.id, 1))		
}
//图片预览
const PicturePreview = ref(false)
const PictureVisible = ref('')
const imgnumList:any = ref([])
let screenHeight = ref(0)
const pictureview = (scope: any)=>{
    screenHeight.value = window.innerHeight - 10;  
    if (scope!==undefined) {
        imgnumList.value = []
        PicturePreview.value = true
        const obj = {
            Id: scope
        }
        downLoadRecordFunction(obj).then((res:any) => {  
            console.log(res)
            imgnumList.value = res.data     
        })
    } else {
        ElMessage.warning("无图片")
    }
}
// 获取打开新增送货预约窗口随机生成预约单号
const randomDeliveryNo = () => {
    createRanDelivery().then((res) => {
        addForm.appointmentNo = res.data
    })
}
// 编辑送货预约窗口默认关闭状态
const drawer = ref(false)

// 编辑送货预约调用窗口内部表单的方法
const dialogRef = ref()

const formRules = {
    deliverGoodsPlaceShip: [{ required: true, message: "发货地不能为空", trigger: "blur" }],
    collectDeliveryPlaceShip: [{ required: true, message: "收货地址不能为空", trigger: "blur" }],
    estimatedDate: [{ required: true, message: "预计到达日期不能为空", trigger: "blur" }
    ],
    deliverDate: [{ required: true, message: "发货日期不能为空", trigger: "blur" }
    ],
    images: [{ required: true, message: "图片上传不能为空", trigger: "blur" }
    ],
}

const disabledDate = (time: Date) => {
    let day = new Date(addForm.deliverDate);
    return time.getTime() < day.getTime() - 3600 * 1000 * 24
}
shipAddress()

const imgjiaji = ref()
//编辑按钮
const addDeliveryAppointment = (scope: any = {}) => {
    console.log(scope)
    imgjiaji.value = scope.purchaseTypeName
    randomDeliveryNo()
    addForm.deliveryId = scope.id
    if (scope.see != null) {
        addForm.id = scope.goodsDeliveryAppointments.id
        addForm.appointmentNo = scope.goodsDeliveryAppointments.appointmentNo
        addForm.transportCompany = scope.goodsDeliveryAppointments.transportCompany
        addForm.expressInfoNo = scope.goodsDeliveryAppointments.expressInfoNo
        addForm.transportVehicle = scope.goodsDeliveryAppointments.transportVehicle
        addForm.driverName = scope.goodsDeliveryAppointments.driverName
        addForm.driverQualification = scope.goodsDeliveryAppointments.driverQualification
        addForm.driverPhone = scope.goodsDeliveryAppointments.driverPhone
        addForm.deliverGoodsPlaceShip = scope.goodsDeliveryAppointments.deliverGoodsPlaceShip
        addForm.collectDeliveryPlaceShip = scope.goodsDeliveryAppointments.collectDeliveryPlaceShip
        addForm.collectDeliveryUserName = scope.goodsDeliveryAppointments.collectDeliveryUserName
        addForm.collectDeliveryUserPhone = scope.goodsDeliveryAppointments.collectDeliveryUserPhone
        addForm.estimatedDate = scope.goodsDeliveryAppointments.estimatedDate
        addForm.deliverDate = scope.goodsDeliveryAppointments.deliverDate
        addForm.images = scope.goodsDeliveryAppointments.imagesList
        const obj = {
            Id: scope.goodsDeliveryAppointments.imagesList
        }
        downLoadRecordFunction(obj).then((res:any) => {
            console.log(res)
            res.data.forEach((item:any)=>{
                let file = {
                    response:{
                        data:item.fileId
                    },
                    name:'',
                    url:item.url
                }
                fileList.value.push(file)
            })                     
        })
    }
    drawer.value = true
    nextTick(() => {
        dialogRef.value.clearValidate()
    })
}
const fileList = ref<UploadUserFile[]>([])
// 移除图片
const handleRemove: UploadProps['onRemove'] = (uploadFile: any, uploadFiles: any) => {
    // console.log('uploadFile',uploadFile)
    // console.log('addForm.images',addForm.images)
    const result = addForm.images.findIndex((item: any) => {
        return item == uploadFile.response.data
    })
    addForm.images.splice(result, 1)
}

//编辑图片预览
const changeBigPic = ref(false)
const dialogImageUrl = ref('')

const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile: any) => {
    // console.log('upload',uploadFile)
    dialogImageUrl.value = uploadFile.url!
    changeBigPic.value = true
}
//上传成功时候的回调
const handleAvatarSuccess: UploadProps['onSuccess'] = (response: any,
    uploadFile: any) => {
        // console.log('response',response)
        // console.log('uploadFile',uploadFile)
        // console.log('file',fileList)
    if (response.code == 200) {
        addForm.images.push(response.data)
        // console.log('addForm.images',addForm.images)
    } else {
        ElMessage.error(`上传失败${response.code}:${response.message}`)
    }
}
// 关闭新增送货预约窗口的Close事件
const handleClose = () => {
    addForm.id = 0
    addForm.appointmentNo = ""
    addForm.transportCompany = ""
    addForm.expressInfoNo = ""
    addForm.transportVehicle = ""
    addForm.driverName = ""
    addForm.driverQualification = ""
    addForm.driverPhone = ""
    addForm.deliverGoodsPlaceShip = ""
    addForm.collectDeliveryPlaceShip = ""
    addForm.collectDeliveryUserName = ""
    addForm.collectDeliveryUserPhone = ""
    addForm.estimatedDate = ""
    addForm.deliverDate = ""
    // deliverGoodsPlaceShipEnum.value = []
    addForm.images = []
    fileList.value = []
    // collectDeliveryPlaceShipEnum.value = []
}
// 编辑提交
const conrirm = () => {
    dialogRef.value.validate((valid: any) => {
        if (valid) {
            addDeliveryNoList(addForm).then((res: any) => {
                // getTableData()
                drawer.value = false
                ElMessage.success('编辑成功')
                handleClose()
            }).catch((err) => {
                ElMessage.error(err.message)
            })

        } else {
            ElMessage.warning("未通过校验")
        }
    })
}
const deliverRef = ref();// 新建送货单按钮
const deliverInfo = ref({})
const creatingShipOrder = (scope: any = {}) => {

  PurchaseOrderdetails({TC001:scope.purchaseType,TC002:scope.purchaseNo,}).then((res: any) => {
        const { data } = res
        if (data.isCreate) {
          deliverInfo.value = scope
          deliverRef.value.show(scope)
        } else {
            ElMessage.warning(data.message)
        }
    })

  // console.log('scope111',scope)
  // console.log('deliverInfo',scope)
 
    // 点击新建送货单时要先判断是否撤销过
    // let params = {
    //     tC001: scope.purchaseType,
    //     tC002: scope.purchaseNo
    // }
    // secondJundgment(params).then((res: any) => {
    //     const { data } = res
    //     if (data.isCreate) {
    //         creatingShipOrderParams.PurchaseID = scope.id
    //         saveData.purchaseID = scope.id
    //         saveData.deliveryType = scope.purchaseType
    //         // drawer.value = true
            
    //         deliverRef.value.show(scope)
    //         systemCreateNo()
    //     } else {
    //         ElMessage.warning(data.message)
    //     }
    // })
}
// 获取系统生成的送货单号,获取送货单详情
const systemCreateNo = () => {
    systemDeNo().then((res) => {
        creatingShipOrderParams.DeliveryNo = res.data
        getCreatingShipOrderData()
    })
}
// 禁止选择项
// 新增/修改弹框数量为0不可选择
// const selectableFunction = (row: any) => {
//     if (row.isCheck == false) {
//         return true
//     } else {
//         return false
//     }
// }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "采购单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).purchaseNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).purchaseNo) = $event)),
                        clearable: "",
                        placeholder: "请输入采购单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "送货单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).deliveryNo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).deliveryNo) = $event)),
                        clearable: "",
                        placeholder: "请输入送货单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "项目编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).ProjectCode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).ProjectCode) = $event)),
                        clearable: "",
                        placeholder: "请输入项目编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getDeDetails
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: reset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        onClick: openSearch,
                        class: "openSearch_Style"
                      }, [
                        _createTextVNode(_toDisplayString(hidden.value ? "收起" : "展开") + " ", 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(hidden.value ? 'el-icon-arrow-up' : 'el-icon-arrow-down')
                        }, null, 2)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (hidden.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "审核状态:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(formModel).Status,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).Status) = $event)),
                              placeholder: "请选择审核状态",
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeEnum.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否加急:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(formModel).IsJiaJiJian,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).IsJiaJiJian) = $event)),
                              placeholder: "请选择是否加急",
                              size: "large",
                              style: {"width":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(isJiaJiJianEnum.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, [
          _createVNode(dragMenu, {
            modelValue: checkedColumns.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checkedColumns).value = $event)),
            checkList: checkList.value,
            "onUpdate:checkList": _cache[6] || (_cache[6] = ($event: any) => ((checkList).value = $event))
          }, null, 8, ["modelValue", "checkList"])
        ])
      ]),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: tableDataDeliveryDrawer.value,
            border: "",
            style: {"width":"100%"},
            "header-cell-style": rowClass,
            "cell-style": cellClass,
            onRowClick: creatingShipDetail,
            ref_key: "singleTableRef",
            ref: singleTableRef,
            "highlight-current-row": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              (checkedColumns.value.indexOf('状态') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    label: "状态",
                    align: "center",
                    prop: "status",
                    width: "120"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_tag, {
                        color: _unref(getStatus)(scope.row.status),
                        effect: "dark",
                        style: {"border":"none","width":"68px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(getText)(scope.row.status)), 1)
                        ]),
                        _: 2
                      }, 1032, ["color"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('项目编号') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    label: "项目编号",
                    align: "center",
                    width: "120",
                    prop: "projectCode"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('采购单号') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 2,
                    label: "采购单号",
                    align: "center",
                    prop: "purchaseNo",
                    width: "130"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('采购类型') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 3,
                    label: "采购类型",
                    align: "center",
                    prop: "purchaseTypeName",
                    width: "100"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('送货总数') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 4,
                    label: "采购总数",
                    align: "center",
                    prop: "purchaseNumber",
                    width: "100"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                label: "已送数量",
                align: "center",
                prop: "deliveryQuantityTotal",
                width: "100"
              }),
              (checkedColumns.value.indexOf('收货数量') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 5,
                    label: "收货数量",
                    align: "center",
                    prop: "collectNumber",
                    width: "100"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('入库数量') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 6,
                    label: "入库数量",
                    align: "center",
                    prop: "warehousingNumber",
                    width: "100"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('返修数量') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 7,
                    label: "返修数量",
                    align: "center",
                    prop: "repairNumber",
                    width: "100"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('采购日期') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 8,
                    label: "采购日期",
                    align: "center",
                    prop: "purchaseDate",
                    width: "180"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('创建时间') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 9,
                    label: "创建时间",
                    align: "center",
                    prop: "createdTime",
                    width: "180"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('更新时间') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 10,
                    label: "更新时间",
                    align: "center",
                    prop: "updatedTime",
                    width: "180"
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('收货地址') >= 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 11,
                    label: "收货地址",
                    align: "center",
                    prop: "address",
                    width: ""
                  }))
                : _createCommentVNode("", true),
              (checkedColumns.value.indexOf('操作') >= 0 && !(_unref(user) == 'admin' || _unref(user)=='superAdmin'))
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 12,
                    align: "center",
                    label: "操作",
                    width: "150"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "el-icon-edit",
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (creatingShipOrder(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Pagination, {
              total: totalItemsDeliveryDrawer.value,
              page: _unref(formModel).PageNo,
              "onUpdate:page": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
              limit: _unref(formModel).PageSize,
              "onUpdate:limit": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
              onPagination: getDeDetails
            }, null, 8, ["total", "page", "limit"])
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_unref(infoBlock), {
        ref_key: "refInfoBlock",
        ref: refInfoBlock,
        info: info.value,
        infoType: infoType.value,
        visible: infoShow.value,
        "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((infoShow).value = $event)),
        onHandOk: reset
      }, null, 8, ["info", "infoType", "visible"]), [
        [_vShow, infoShow.value]
      ]),
      _withDirectives(_createVNode(_unref(infoAdd), {
        info: _unref(infoAdd),
        infoType: infoType.value,
        visible: infoAddShow.value,
        "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((infoAddShow).value = $event))
      }, null, 8, ["info", "infoType", "visible"]), [
        [_vShow, infoAddShow.value]
      ]),
      _createVNode(_unref(addDeliver), {
        deliverInfo: deliverInfo.value,
        ref_key: "deliverRef",
        ref: deliverRef,
        onHandOk: reset
      }, null, 8, ["deliverInfo"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: drawers.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((drawers).value = $event)),
      direction: "rtl",
      size: "90%",
      onClose: handleCloses,
      "show-close": false,
      "with-header": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createVNode(_component_el_button, {
              type: checkRows.value.length == 0 ? 'info' : 'primary',
              disabled: checkRows.value.length == 0,
              onClick: confirmNewDeliveryOrder
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["type", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(ElTable), {
              data: tableDataDrawer.value,
              "row-key": "xuHao",
              ref_key: "TableRef",
              ref: TableRef,
              border: "",
              "header-cell-style": rowClass,
              style: {"width":"100%","margin-top":"20px"},
              onSelectionChange: handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  align: "center",
                  width: "60",
                  type: "selection",
                  "reserve-selection": "",
                  selectable: selectableFunction
                }),
                _createVNode(_component_el_table_column, {
                  label: "项目编号",
                  align: "center",
                  fixed: "",
                  prop: "projectCode",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  align: "center",
                  prop: "xuHao"
                }),
                _createVNode(_component_el_table_column, {
                  label: "主件品号",
                  align: "center",
                  prop: "mainCode",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "品名",
                  align: "center",
                  prop: "name",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "品号",
                  align: "center",
                  prop: "code",
                  width: "120"
                }),
                _createVNode(_component_el_table_column, {
                  label: "规格型号",
                  align: "center",
                  width: "250",
                  prop: "specificationModel"
                }),
                _createVNode(_component_el_table_column, {
                  label: "单位",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.unit), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "检验方式",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(getInspectionMethod)(scope.row.inspectionMethod)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "品牌名称",
                  align: "center",
                  prop: "brandName",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "是否结束",
                  align: "center",
                  prop: "isEnd",
                  width: "160"
                }),
                _createVNode(_component_el_table_column, {
                  label: "总发货数",
                  align: "center",
                  prop: "purchaseNumber"
                }),
                _createVNode(_component_el_table_column, {
                  label: "未配送数",
                  align: "center",
                  prop: "notPurchaseNumber"
                }),
                _createVNode(_component_el_table_column, {
                  label: "已送货数",
                  align: "center",
                  prop: "outdeliveryQuantity"
                }),
                _createVNode(_component_el_table_column, {
                  label: "退货数",
                  align: "center",
                  prop: "returnQuantity"
                }),
                _createVNode(_component_el_table_column, {
                  label: "本次发货数量",
                  align: "center",
                  width: "160",
                  fixed: "right"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_input_number, {
                      min: "0",
                      max: scope.row.purchaseNumber + scope.row.returnQuantity - scope.row.outdeliveryQuantity,
                      class: "edit-pipeline",
                      modelValue: scope.row.deliveryQuantity,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.deliveryQuantity) = $event),
                      modelModifiers: { number: true },
                      size: "small"
                    }, null, 8, ["max", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(Pagination, {
              total: tableDataItems.value,
              page: _unref(creatingShipOrderParams).PageNo,
              "onUpdate:page": _cache[11] || (_cache[11] = ($event: any) => ((_unref(creatingShipOrderParams).PageNo) = $event)),
              limit: _unref(creatingShipOrderParams).PageSize,
              "onUpdate:limit": _cache[12] || (_cache[12] = ($event: any) => ((_unref(creatingShipOrderParams).PageSize) = $event)),
              onPagination: changerole,
              style: {"margin-top":"20px","text-align":"center"}
            }, null, 8, ["total", "page", "limit"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: drawer.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((drawer).value = $event)),
      title: "编辑送货预约",
      width: "50%",
      onClose: handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (drawer.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: conrirm
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, " 预约单号:" + _toDisplayString(_unref(addForm).appointmentNo), 1),
          _createVNode(_component_el_form, {
            model: _unref(addForm),
            "label-width": "130px",
            ref_key: "dialogRef",
            ref: dialogRef,
            rules: formRules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "运输公司:",
                        prop: "transportCompany"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).transportCompany,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addForm).transportCompany) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择运输公司",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transportCompanyEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "运输车辆:",
                        prop: "transportVehicle"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).transportVehicle,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addForm).transportVehicle) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择运输车辆",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transportVehicleEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "司机姓名:",
                        prop: "driverName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).driverName,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(addForm).driverName) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择司机姓名",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(driverNameEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "司机电话:",
                        prop: "driverPhone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).driverPhone,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(addForm).driverPhone) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择司机电话",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(driverPhoneEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "驾驶员资格:",
                        prop: "driverQualification"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).driverQualification,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addForm).driverQualification) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择驾驶员资格",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(driverQualificationEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "物流单号:",
                        prop: "expressInfoNo"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).expressInfoNo,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addForm).expressInfoNo) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择物流单号",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expressInfoNoEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "收货人:",
                        prop: "collectDeliveryUserName"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).collectDeliveryUserName,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addForm).collectDeliveryUserName) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择收货人",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collectDeliveryUserNameEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "收货人电话:",
                        prop: "collectDeliveryUserPhone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).collectDeliveryUserPhone,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(addForm).collectDeliveryUserPhone) = $event)),
                            clearable: "",
                            "allow-create": "",
                            filterable: "",
                            placeholder: "请选择收货人电话",
                            size: "large",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collectDeliveryUserPhoneEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "发货地址:",
                        prop: "deliverGoodsPlaceShip"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            ref: "loanTypeSelect",
                            modelValue: _unref(addForm).deliverGoodsPlaceShip,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(addForm).deliverGoodsPlaceShip) = $event)),
                            clearable: "",
                            "default-first-option": "",
                            placeholder: "请选择发货地址",
                            size: "large",
                            "allow-create": "",
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliverGoodsPlaceShipEnum.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.label,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "收货地址:",
                        prop: "collectDeliveryPlaceShip"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(addForm).collectDeliveryPlaceShip,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(addForm).collectDeliveryPlaceShip) = $event)),
                            clearable: "",
                            placeholder: "请选择收货地址",
                            size: "large",
                            style: {"width":"100%"},
                            filterable: "",
                            "allow-create": ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collectDeliveryPlaceShipEnum.value, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: item.label,
                                  value: item.label
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "发货日期:",
                        prop: "deliverDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _unref(addForm).deliverDate,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(addForm).deliverDate) = $event)),
                            "value-format": "YYYY-MM-DD",
                            type: "date",
                            placeholder: "请选择发货日期",
                            style: {"width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "预计到达日期:",
                        prop: "estimatedDate"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _unref(addForm).estimatedDate,
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addForm).estimatedDate) = $event)),
                            "value-format": "YYYY-MM-DD",
                            type: "date",
                            placeholder: "请选择预计到达日期",
                            style: {"width":"100%"},
                            "disabled-date": disabledDate
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      (imgjiaji.value=='外协机加')
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "图片上传:",
                            prop: "images"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_upload, {
                                "file-list": fileList.value,
                                "onUpdate:file-list": _cache[26] || (_cache[26] = ($event: any) => ((fileList).value = $event)),
                                headers: headerObj.value,
                                "on-success": handleAvatarSuccess,
                                fit: "cover",
                                action: _unref(actionUrl),
                                "list-type": "picture-card",
                                "on-remove": handleRemove,
                                "on-preview": handlePictureCardPreview
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_badge, null, {
                                    default: _withCtx(() => [
                                      _hoisted_17
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["file-list", "headers", "action"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 1,
                            label: "图片上传:",
                            prop: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_upload, {
                                "file-list": fileList.value,
                                "onUpdate:file-list": _cache[27] || (_cache[27] = ($event: any) => ((fileList).value = $event)),
                                headers: headerObj.value,
                                "on-success": handleAvatarSuccess,
                                fit: "cover",
                                action: _unref(actionUrl),
                                "list-type": "picture-card",
                                "on-remove": handleRemove,
                                "on-preview": handlePictureCardPreview
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_badge, null, {
                                    default: _withCtx(() => [
                                      _hoisted_18
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["file-list", "headers", "action"])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})